import { useEffect, useState } from "react";
import { repositoryMdm } from "../../../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../../../model/MessageResponse";
import { Checkbox, ScrollArea, Table } from "@mantine/core";
import cx from "clsx";
import classes from "../../../../../../Styles/TableScrollArea.module.css";

interface saleChannelModel {
  id: number;
  code: string;
  name: string;
  isCheck: boolean;
  active?: boolean;
  stt?: number;
}

const SaleChannel = ({
  data,
  successCall,
}: {
  data: any;
  successCall: boolean;
}) => {
  const [height, setHeight] = useState(0);
  const [scrolled, setScrolled] = useState(false);
  const [dataSaleChannel, setDataSaleChannnel] = useState<saleChannelModel[]>(
    []
  );

  const getDataSaleChannel = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblDmSaleChanel/get-all"
    );

    if (res && res.success) {
      if (data?.includes("all")) {
        const result = res.data
          ?.filter((item: any) => item.active)
          ?.map((item: any) => ({
            id: item.id,
            code: item.code,
            name: item.name,
          }));
        setDataSaleChannnel(result);
      } else {
        const result = res.data
          ?.filter(
            (item: any) => item.active && data?.includes(String(item.id))
          )
          ?.map((item: any) => ({
            id: item.id,
            code: item.code,
            name: item.name,
          }));
        setDataSaleChannnel(result);
      }
    }
  };

  useEffect(() => {
    if (successCall) {
      getDataSaleChannel();
    }
  }, [successCall]);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight - 440);
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  return (
    <ScrollArea
      h={height}
      onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
    >
      <Table mt={10}>
        <Table.Thead
          className={cx(classes.header, {
            [classes.scrolled]: scrolled,
          })}
        >
          <Table.Tr>
            <Table.Th>Mã kênh bán</Table.Th>
            <Table.Th>Tên kênh bán</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {dataSaleChannel &&
            dataSaleChannel.length > 0 &&
            dataSaleChannel.map((item) => (
              <Table.Tr key={item.id}>
                <Table.Td>{item.code}</Table.Td>
                <Table.Td>{item.name}</Table.Td>
              </Table.Tr>
            ))}
        </Table.Tbody>
      </Table>
    </ScrollArea>
  );
};

export default SaleChannel;
